/**
 * Development-only tracing.
 *
 * Thirteen console.log calls shipped to production, narrating the session on
 * every user's console: that a JWT was absorbed from a URL parameter, that a
 * CSRF token was stored, how many visits loaded, which H3 cells were visible.
 * None of them logs a secret, but none of them belongs in a user's browser
 * either — and a console full of trace noise hides the errors that matter.
 *
 * They are worth keeping for local work, so they route through here instead of
 * being deleted. CRA sets NODE_ENV to "production" for a build, so the branch
 * is statically false there and the minifier drops both the call and its
 * arguments — including any template string that would otherwise be built.
 *
 * console.error and console.warn are deliberately left alone: a real failure
 * should surface wherever it happens.
 */
export const debug = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export default debug;
